<script setup>
import {
  IconLayoutDashboard,
  IconMessageCircle,
  IconMessageCode,
  IconTicket,
  IconChartDots3,
  IconPhoneRinging,
  IconBuildingBroadcastTower,
  IconBook,
  IconRobot,
  IconLinkPlus,
  IconClipboardText,
  IconSettings,
  IconMessage,
  IconMail,
  IconBubbleText,
  IconUsers,
  IconPhone,
  IconCommand,
  IconBrandWhatsapp,
  IconTemplate,
  IconCast,
  IconMessageCircleUser,
  IconMessageCheck,
  IconCode,
  IconObjectScan,
  IconListTree,
  IconVolume,
  IconMessage2Share,
  IconMessageExclamation,
  IconBasketCog,
  IconPlus,
  IconUserPlus,
  IconMicrophone,
  IconNews,
  IconCategory2,
  IconFileSettings,
  IconRobotFace,
  IconBook2,
  IconTerminal2,
  IconDashboard,
  IconUserCheck,
  IconMessage2Check,
  IconSocial,
  IconGitCompare,
  IconClipboardList,
  IconStar,
  IconAddressBook,
  IconUserScan,
  IconFileDescription,
} from "@tabler/icons-vue";

import { computed } from "vue";

const props = defineProps({
  icon: String,
  isActive: Boolean,
  isSubmenu: {
    default: false,
    type: Boolean,
  },
});

const iconMap = {
  1: IconLayoutDashboard,
  3: IconMessageCircle,
  2: IconMessageCode,
  6: IconTicket,
  5: IconChartDots3,
  12: IconPhoneRinging,
  10: IconBuildingBroadcastTower,
  9: IconBook,
  11: IconRobot,
  4: IconLinkPlus,
  8: IconClipboardText,
  7: IconSettings,
  13: IconAddressBook, // CRM

  // Message
  "9-1": IconMessage, // Conversation:Chat
  "9-2": IconMail, // Conversation:Mail
  "9-3": IconBubbleText, // Conversation:Comment

  "10-4": IconUsers, // Customers:Customer List

  "11-5": IconPhone, // Voip:Call

  "12-6": IconCommand, // Broadcast:Broadcast by Channel
  "12-7": IconBuildingBroadcastTower, // Broadcast:Broadcast Message
  "12-8": IconBrandWhatsapp, // Broadcast:Whatsapp non HSM

  "13-9": IconCast, // Whatsapp:Broadcast Message
  "13-10": IconTemplate, // Whatsapp:Broadcast Template
  "14-11": IconMessageCircleUser,
  "14-12": IconMessageCheck,
  "14-13": IconCode,
  "14-14": IconObjectScan,
  "15-15": IconListTree,
  "15-16": IconVolume,
  "15-17": IconMessage2Share,
  "15-18": IconMessageExclamation,

  "16-19": IconBasketCog,
  "18-20": IconPlus,
  "18-21": IconTicket,

  "19-22": IconUserPlus,
  "19-23": IconUsers,

  "36-97": IconMicrophone,
  "36-96": IconLayoutDashboard,
  "36-98": IconClipboardText,

  "35-93": IconNews,
  "35-94": IconCategory2,
  "35-95": IconFileSettings,

  "34-90": IconRobotFace,
  "34-91": IconBook2,
  "34-92": IconTerminal2,
  "34-101": IconDashboard,

  "38-111": IconUserCheck,
  "38-112": IconMessage2Check,
  "39-114": IconSocial,
  "39-115": IconGitCompare,
  "39-116": IconClipboardList,
  "41-117": IconStar,

  // CRM
  "42-120": IconUserScan, // CRM:Leads
  "42-121": IconFileDescription, // CRM:Report
  "42-122": IconSettings, // CRM:Setting
};

const iconDisplay = computed(() => {
  return iconMap[props.icon] || IconLayoutDashboard;
});
</script>

<template>
  <component
    :is="iconDisplay"
    :is-submenu="isSubmenu"
    :color="isActive ? (isSubmenu ? '#678af3' : '#fff') : '#9ba1b6'"
    size="20"
  ></component>
</template>
